<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { ref } from "vue";

import Select from "primevue/select";

import { type StoredObject, useComparisonStore } from "../comparison-store";

defineProps<{
  dark?: boolean;
  size?: string;
}>();

const comparisonStore = useComparisonStore();
const { unselectedObjects } = storeToRefs(comparisonStore);
const { addObject } = comparisonStore;

const addModel = ref<StoredObject | null>(null);

function onAdd(obj: StoredObject) {
  addObject(obj.key);
  addModel.value = null;
}
</script>

<template>
  <Select
    v-if="unselectedObjects.length > 0"
    v-model="addModel"
    v-bind="$attrs"
    :options="unselectedObjects"
    :size="size"
    :option-label="(obj) => `(${obj.type.value}) ${obj.name.value}`"
    filter
    placeholder="Zoek"
    :pt="
      dark
        ? {
            root: {
              class:
                '!bg-white/10 !border-white/20 hover:!border-white/40 !shadow-none',
            },
            label: { class: '!text-white/70 !text-xs' },
            dropdown: { class: '!text-white/50' },
          }
        : undefined
    "
    @update:model-value="onAdd"
  />
</template>
